import { useLocation } from 'react-router-dom';
import type { DocTypeData } from '../types';
import { getDocsViewDocType } from '../utils/docsView';

export function useDocsView(): DocTypeData | undefined {
  const { search } = useLocation();
  return getDocsViewDocType(search);
}
